import { useState } from 'vuex-composition-helpers';
import { IMapForFiltersState } from '@ve/components/hotel/filters/common/store/types';
import {
    computed, Ref, ref, unref, watch,
} from 'vue';
import _ from 'underscore';
import { wordEnding } from '@ve/services/textModifiers';
import { Operator } from '@ve/types';

const filtersMappingStoreName = 'mapForFilters';

export default ({
                    selectedOperators,
                }: {
    selectedOperators: Ref<number[]>;
}) => {
    const {
        products,
    } = useState<IMapForFiltersState>(filtersMappingStoreName, ['products']);

    const currentOperatorsReference = computed(() => _.uniq(unref(products).map((product) => product.operator), (opeartor) => opeartor.id));

    // каждый новый поиск приносит туры от операторов и справочник доступных операторов обновляется.
    // Если вдруг так получилось, что выбран фильтр по какому-то туроператору, который не пришел в новой выдаче, то этот оператор должен отобразиться выбранным из reserveOperators списка всех операторов, которые были получены за всю историю работы страницы, чтобы его можно было отключить. Никакие фильтры автоматически не сбрасываются
    const reservedOperators: Ref<Operator[]> = ref([]);
    watch(currentOperatorsReference, (operatorsReference) => {
        reservedOperators.value = _.uniq(([] as Operator[]).concat(unref(reservedOperators), operatorsReference), (opeartor) => opeartor.id);
    });
    const reservedOperatorsReference = computed(() => {
        const operatorsValue = unref(selectedOperators);
        if (!operatorsValue.length) return [];

        const reservedOperatorsReferenceValue: Operator[] = [];
        unref(selectedOperators).forEach((operatorId) => {
            if (!_.findWhere(unref(currentOperatorsReference), { id: operatorId })) {
                const reservedOperator = _.findWhere(unref(reservedOperators), { id: operatorId });
                if (reservedOperator) {
                    reservedOperatorsReferenceValue.push(reservedOperator);
                }
            }
        });
        return reservedOperatorsReferenceValue;
    });

    const operatorsReference = computed(() => ([] as Operator[]).concat(unref(currentOperatorsReference), unref(reservedOperatorsReference)));

    const selectedOperatorsText = computed(() => {
        const selectedOperatorsValue = unref(selectedOperators);
        if (selectedOperatorsValue.length === 1) {
            return unref(operatorsReference).find((operator) => operator.id === selectedOperatorsValue[0])?.name;
        }
        if (selectedOperatorsValue.length > 1) {
            return `${selectedOperatorsValue.length} туроператор${wordEnding(selectedOperatorsValue.length, ';а;ов')}`;
        }
        return 'Все туроператоры';
    });

    const moreThanOneOperatorAvailableOrSelected = computed(() => unref(operatorsReference).length > 1 || unref(selectedOperators).length);

    const allOperatorsChecked = computed({
        get: () => !unref(selectedOperators).length,
        set: (value) => {
            if (value) {
                selectedOperators.value = [];
            }
        },
    });

    return {
        selectedOperatorsText,
        operatorsReference,
        moreThanOneOperatorAvailableOrSelected,
        allOperatorsChecked,
    };
};
